import { type EmailMessage } from '@/types/EmailMessage'
import { useSettingsStore } from '@/stores/settings'

export function createEmail(data: Partial<EmailMessage>): EmailMessage {
  const settingsStore = useSettingsStore()
  const { emailSettings } = settingsStore

  return {
    id: data.id || crypto.randomUUID(),
    to: data.to || '',
    message: {
      subject: data.message?.subject || '',
      html: data.message?.html,
      text: data.message?.text,
      messageId: data.message?.messageId,
      attachments: data.message?.attachments || [],
    },
    from: data.from || emailSettings.defaultFrom,
    replyTo: data.replyTo || emailSettings.replyTo,
    toUids: data.toUids,
    cc: data.cc,
    ccUids: data.ccUids,
    bcc: data.bcc || emailSettings.autoBcc ? emailSettings.defaultFrom : undefined,
    bccUids: data.bccUids,
    headers: data.headers,
    template: data.template,
    meta: (data as any).meta,
    sentAt: new Date(),
    personId: data.personId,
    organizationId: data.organizationId,
  }
}
